@if (isLoaded && requisition) {
  <rt-requisitions-toolbar-container
    [requisition]="requisition"
    [assignments]="assignments"
  ></rt-requisitions-toolbar-container>
  <router-outlet></router-outlet>
  <rt-requisitions-drop-area-container
    [requisitionId]="requisition.id"
    [dragEventData]="dragEventData"
  ></rt-requisitions-drop-area-container>
} @else {
  <rt-spinner></rt-spinner>
}
